module.exports = __webpack_public_path__ + "media/img/img-about-2-8edfaf6f.png";